import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput, FormHelperText,
  TextField
} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {useState} from "react";
import {confirmAlert} from "react-confirm-alert";
import {API} from "../framework/api";

export function RegistrationPage(props) {

  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [password2Error, setPassword2Error] = useState(false);

  const [values, setValues] = useState({
    username: '',
    password: '',
    password2: '',
    email: '',
    freeText: '',
    showPassword: false,
    showPassword2: false,
  });

  const handleChange = (event, prop) => {
    setValues({ ...values, [prop]: event.target.value });

    switch (prop) {
      case 'username':
        setUsernameError(event.target.value.length < 5);
        break;
      case 'password':
        setPasswordError(event.target.value.length < 6);
        break;
      case 'password2':
        setPassword2Error(event.target.value != values.password);
        break;
      default: // No action
    }
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleClickShowPassword2 = () => {
    setValues({
      ...values,
      showPassword2: !values.showPassword2,
    });
  };

  const handleCreateAccount = () => {
    if (values.password != values.password2) {
      confirmAlert({
        title: "Lösenordet stämmer inte. Var kod kontrollera och försök igen.",
        buttons: [{
          label: "Ok",
          onClick: () => {}
        }]
      });
      return;
    }
    if (values.email.length == 0) {
      confirmAlert({
        title: `Du skapar nu ett helt anonymt konto. Du måste komma ihåg ditt användarnamn '${values.username}' samt ditt lösenord för att kunna kommunicera med oss.`,
        buttons: [{
          label: "Skapa konto",
          onClick: () => { handleCreateAccountConfirmed() }
        },{
          label: "Avbryt",
          onClick: () => {}
        }]
      });
    } else {
      handleCreateAccountConfirmed();
    }
  }

  const handleCreateAccountConfirmed = () => {
    API.getAPI().auth_create(values).then(()=> {
      window.location.hash="#/profile";
    }).catch((e) => {
      let msg = "Kontot kunde inte skapas. Kontrollera dina kontouppgifter och försök igen. ";
      if (e.response && e.response.data && e.response.data.message) {
        msg += `Servern rapporterade: '${e.response.data.message}'.`;
      }
      confirmAlert({
        title: "Konto kunde inte skapas",
        message: msg,
        buttons: [{
          label: "Avfärda",
          onClick: () => {}
        }]
      });
      console.error(e);
    });
  }

  return (
    <div>
      <div className={"App-title"}>Registrera dig</div>
        <div className={"App-container App-drop-shadow"}>
          <Grid container={true} spacing={2}>
            <Grid item xs={12} sm={12}>
              <div className={"App-fieldTitle"}>Fyll i användarnamn</div>
            </Grid>
            <Grid item xs={12} sm={12}>

              {/*** Användarnamn ***/}

              <TextField
                fullWidth={1}
                id="outlined-basic"
                label="Användarnamn"
                variant="outlined"
                value={values.username}
                error={usernameError}
                helperText={usernameError ? "Måste bestå av minst 5 tecken" : ""}
                onChange={(e)=> handleChange(e, 'username')}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={"App-fieldTitle"}>Fyll i ditt lösenord</div>
            </Grid>
            <Grid item xs={12} sm={12}>

              {/*** Lösenord ***/}

              <FormControl variant="outlined" fullWidth={1}>
                <InputLabel htmlFor="outlined-adornment-password">Lösenord</InputLabel>
                <OutlinedInput
                  fullWidth={1}
                  id="outlined-adornment-password"
                  type={values.showPassword ? 'text' : 'password'}
                  value={values.password}
                  error={passwordError}
                  onChange={(e) => handleChange(e, 'password')}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                      >
                        {values.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                {passwordError ?<FormHelperText id="outlined-adornment-password-helper-text" className={"Mui-error"}>Måste bestå av minst 6 tecken</FormHelperText>: null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={"App-fieldTitle"}>Bekräfta ditt lösenord</div>
            </Grid>
            <Grid item xs={12} sm={12}>

              {/*** Lösenord ***/}

              <FormControl variant="outlined" fullWidth={1}>
                <InputLabel htmlFor="outlined-adornment-password">Upprepa lösenord</InputLabel>
                <OutlinedInput
                  fullWidth={1}
                  id="outlined-adornment-password"
                  type={values.showPassword2 ? 'text' : 'password'}
                  value={values.password2}
                  error={password2Error}
                  onChange={(e) => handleChange(e, 'password2')}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        edge="end"
                      >
                        {values.showPassword2 ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
                {password2Error ?<FormHelperText id="outlined-adornment-password2-helper-text" className={"Mui-error"}>Måste överensstämma med lösenordet</FormHelperText>: null}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={"App-fieldTitle"}>Få uppdateringar när vi hittat en matchning? Fyll i din mailadress.</div>
            </Grid>
            <Grid item xs={12} sm={12}>

              {/*** Email (frivilligt) ***/}

              <TextField
                fullWidth={1}
                type="email"
                id="outlined-basic"
                label="E-post (frivilligt)"
                variant="outlined"
                value={values.email}
                onChange={(e)=> handleChange(e, 'email')}
              />
            </Grid>
            <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

              {/*** Submitknapp ***/}

              <Button
                className={"App-button-text"}
                variant={"text"}
                onClick={() => { document.location.hash="#/login" }}
              >
                Logga in
              </Button>

              <Button
                className={"App-button-contained"}
                variant={"contained"}
                onClick={handleCreateAccount}
              >
                Registrera dig
              </Button>
            </Grid>
            <Grid item xs={12} sm={12}>

            </Grid>
          </Grid>
        </div>
      <div className={"App-footer"}>
        {/*** Hjälptext och länk till login ***/}

        Har du redan ett konto? Klicka <span className={"u-clickable u-bold"} onClick={() => { document.location.hash="#/login" }}>här för att logga in</span>.
      </div>
    </div>
  );
}
